export const ADMIN_CREDENTIALS = {
  email: 'admin@market.com',
  password: '183113poa'
};
